<script setup>
import { useRouter } from "vue-router";
import AppDataTable from "@/components/AppDataTable.vue";
import ConfirmDialog from "@/components/ConfirmDialog.vue";
import { useResourceList } from "@/composables/useResourceList";
import { fetchRedemptionProducts, deleteRedemptionProduct } from "./api";

const router = useRouter();
const columns = [
  { key: "image",   label: "Image",   width: "72px" },
  { key: "title",   label: "Title",   sortable: true },
  { key: "points",  label: "Points",  sortable: true },
  { key: "actions", label: "Actions", align: "end", width: "150px" },
];
const { rows, loading, error, pendingDelete, deleting, load, askDelete, confirmDelete } =
  useResourceList({
    fetch: fetchRedemptionProducts,
    remove: deleteRedemptionProduct,
    mapRow: (r) => ({ id: r._id, image: r.imgUrl ?? r.imageUrl ?? r.image ?? r.img ?? null, title: r.name ?? r.title ?? "—", points: r.points }),
  });
</script>

<template>
  <section>
    <div class="d-flex align-center justify-space-between mb-4 gap-3 flex-wrap">
      <h1 class="text-h5">Redemption Products</h1>
      <div class="d-flex gap-2">
        <VBtn variant="tonal" @click="load">Refresh</VBtn>
        <VBtn @click="router.push({ name: 'redemption-products-new' })">Add Product</VBtn>
      </div>
    </div>
    <VAlert v-if="error" type="error" closable class="mb-4" @click:close="error = ''">{{ error }}</VAlert>
    <AppDataTable :columns="columns" :rows="rows" :loading="loading" row-key="id" searchable search-placeholder="Search products…" empty-text="No products yet.">
      <template #cell-image="{ row }">
        <img v-if="row.image" :src="row.image" alt="" style="width:48px;height:48px;object-fit:cover;border-radius:4px;display:block" />
        <span v-else class="text-disabled">—</span>
      </template>
      <template #cell-actions="{ row }">
        <VBtn size="small" variant="text" @click.stop="router.push({ name: 'redemption-products-edit', params: { id: row.id } })">Edit</VBtn>
        <VBtn size="small" color="error" variant="text" @click.stop="askDelete(row)">Delete</VBtn>
      </template>
    </AppDataTable>
    <ConfirmDialog :model-value="pendingDelete !== null" title="Delete product?" :message="`Delete &quot;${pendingDelete?.title || 'this product'}&quot;?`" :loading="deleting" @update:model-value="pendingDelete = null" @confirm="confirmDelete" />
  </section>
</template>
